/*
* @Description: 提货司机管理
* @Author: ma.cq
* @Date: 2018-10-18 10:47:29
* @LastEditors: ma.cq
* @LastEditTime: 2018-10-18 11:53:26
*/
<template>
  <div class="driver-manager" @keyup.enter="enterSearch">
    <el-form class="table-search-bar" inline ref="driverForm" :model="driverForm">
      <el-form-item label="司机姓名" prop="driverName">
        <el-input v-model="driverForm.driverName" placeholder="请输入司机名"></el-input>
      </el-form-item>
      <el-form-item label="手机" prop="phone">
        <el-input v-model="driverForm.phone" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="identityCard">
        <el-input v-model="driverForm.identityCard" placeholder="请输入身份证号"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="driverForm.status">
          <el-option v-for="item in statusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜 索</el-button>
        <el-button type="primary" @click="reset">重 置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="driverList"
      style="width: 100%"
      tooltip-effect="light">
      <el-table-column
        prop="driverName"
        label="司机姓名"
        width="180"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="phone"
        label="手机"
        width="180"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="identityCard"
        label="身份证号"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="trustPoint"
        label="信誉值"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        width="100"
        label="状态"
        :formatter="statusFormatter"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="操作" width="320">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleCheck(scope.$index, scope.row)" v-permission="'0120701'">查看</el-button>
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)" v-permission="'0120702'">编辑</el-button>
          <el-button size="mini" v-if="scope.row.status === 2" @click="outBlackList(scope.row)" v-permission="'0120704'">解除黑名单</el-button>
          <el-button size="mini" v-else @click="joinBlackList(scope.row)" v-permission="'0120705'">加入黑名单</el-button>
          <el-button v-if="scope.row.status === 3" size="mini" @click="verify(scope.row)" v-permission="'0120703'">审核</el-button>
          <el-button v-if="scope.row.status === 5" size="mini" @click="unbund(scope.row)" v-permission="'0120706'">解绑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      :current-page="listState.pageNo"
      :total="listState.total"
      layout="total, sizes, prev, pager, next, jumper"
      background>
    </el-pagination>
    <check-dialog :show.sync="checkDialogShow" :form-data="checkData"/>
    <edit-dialog :show.sync="editDialogShow" :form-data="editData"/>
    <verify-dialog :show.sync="verifyDialogShow" :form-data="verifyData"/>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import CheckDialog from './checkDialog'
import EditDialog from './editDialog'
import VerifyDialog from './verifyDialog'

export default {
  name: 'driverManager',
  components: { CheckDialog, EditDialog, VerifyDialog },
  data () {
    return {
      driverForm: {
        driverName: '',
        identityCard: '',
        phone: '',
        status: 0
      },
      statusOptions: [
        {
          label: '全部',
          value: 0
        },
        {
          label: '正常',
          value: 1
        },
        {
          label: '黑名单',
          value: 2
        },
        {
          label: '待审核',
          value: 3
        },
        {
          label: '审核未通过',
          value: 4
        },
        {
          label: '审核通过',
          value: 5
        }
      ],
      checkData: {},
      checkDialogShow: false,
      editData: {},
      editDialogShow: false,
      verifyData: {},
      verifyDialogShow: false
    }
  },
  computed: {
    ...mapGetters({ driverList: 'getDriverList', listState: 'getTrustPointList' })
  },
  methods: {
    ...mapActions(['getDriver', 'getTrustPoint', 'unbundDriver', 'toggleBlackList']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    handleSearch () {
      const params = { ...this.driverForm, pageNo: 1 }
      this.getDriver(params)
    },
    handleCheck (index, row) {
      this.checkData = row
      this.checkDialogShow = true
    },
    handleSizeChange (val) {
      this.getDriver({ pageSize: val, pageNo: 1 })
    },
    handleCurrentChange (val) {
      this.getDriver({ pageNo: val })
    },
    reset () {
      this.$refs['driverForm'].resetFields()
      this.handleSearch()
    },
    handleEdit (index, row) {
      this.editData = { ...row }
      this.editDialogShow = true
    },
    joinBlackList (row) {
      this.toggleBlackList({ accountId: row.id }).then(() => {
        this.$message.success('操作成功')
        this.handleSearch()
      })
    },
    outBlackList (row) {
      this.toggleBlackList({ accountId: row.id }).then(() => {
        this.$message.success('操作成功')
        this.handleSearch()
      })
    },
    verify (row) {
      this.verifyData = row
      this.verifyDialogShow = true
    },
    unbund (row) {
      this.$confirm('是否确认解绑', '解绑提醒', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.unbundDriver({ id: row.id }).then(() => {
          this.handleSearch()
          this.$message({
            type: 'success',
            message: '解绑成功!'
          })
        })
      }).catch(() => {
        // 取消删除
      })
    },
    statusFormatter (row) {
      return this.statusOptions.find(item => item.value === row.status).label
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>
